import EEA_COUNTRIES from './eea';

const SCHENGEN_COUNTRIES = [
  'CH',
  ...EEA_COUNTRIES.filter((country) => !['IE', 'CY'].includes(country)),
];

export default SCHENGEN_COUNTRIES;
